import { Link } from "react-router-dom";
import Layout from "@/components/site/Layout";
import { newsCategories } from "@/mocks/categories";

function NotFound() {
  return (
    <Layout>
      <div className="mx-auto flex max-w-6xl flex-col items-center px-4 py-20 text-center md:px-6 md:py-28">
        <p className="font-heading text-7xl font-black text-primary-200 md:text-8xl">404</p>
        <h1 className="mt-4 font-heading text-2xl font-black text-foreground-950 md:text-3xl">这页还没「开瓜」</h1>
        <p className="mt-3 max-w-md text-sm leading-6 text-foreground-600">
          你访问的页面不存在或已被移动。今天的要闻、直播和栏目都在首页等你看。
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/live"
            className="whitespace-nowrap rounded-md border border-background-200 px-6 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            去看直播
          </Link>
        </div>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
          {newsCategories.map((c) => (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className="whitespace-nowrap rounded-full bg-background-100 px-4 py-1.5 text-sm text-foreground-600 transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              {c.name}快讯
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  );
}

export default NotFound;